export var CommandBarStyles = function (props) {
    var theme = props.theme;
    var palette = theme.palette;
    return {
        root: [
            {
                height: 44,
                padding: '0 14px 0 24px',
                backgroundColor: palette.white,
            },
        ],
    };
};
//# sourceMappingURL=CommandBar.styles.js.map